/** Copyright 2024 SAP SE or an SAP affiliate company. All rights reserved. */

import { RootState } from '@/store/reducer';
import { createStyles } from '@/utils/styles';
import { BusyIndicator, Dialog } from '@ui5/webcomponents-react';
import { useSelector } from 'react-redux';

const LoadingDialog = () => {
    const isLoading = useSelector((state: RootState) => state.loadingReducer.pendingRequests > 0);

    return (
        <Dialog open={isLoading} data-testid="loading-dialog" preventInitialFocus>
            <div style={styles.wrapper}>
                <BusyIndicator active delay={0} />
            </div>
        </Dialog>
    );
};

export default LoadingDialog;

const styles = createStyles({
    wrapper: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        display: 'flex',
        alignItems: 'center',
    },
});
